import { Injectable } from '@angular/core';
import {ConstantService} from '../../constant/constant.service';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor(
      public constantService : ConstantService,
      public http :HttpClient
  ) { }

    getStates(){
        return this.http.get(this.constantService.getUrl(this.constantService.PINCODE,['states']));
    }
    getCites(stateId){
        return this.http.get(this.constantService.getUrl(this.constantService.PINCODE,['cities',stateId]));
    }
    getPincodes(cityId){
        return this.http.get(this.constantService.getUrl(`${this.constantService.PINCODE}/lookup`,[cityId]));
    }
}
